import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-device',
    templateUrl: './device.component.svg',
    styleUrls: ['./device.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceComponent {}
